(function (global) {
    define('LNRS/Components/ContentSlider',[
        "jquery", "vue", "underscore", "lightslider", "matchHeight", "eventManager"
    ], function ($, Vue, _, lightslider, matchHeight, eventManager) {

        var component = {
            mounted: function () {
                $(".light-slider", this.$el).lightSlider({
                    pager: false,
                    item: this.displayedPerScrollOnDesktop,
                    slideMove: this.scrollStepOnDesktop,
                    slideMargin: this.slideMarginOnDesktop,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                item: this.displayedPerScrollOnDesktop,
                                slideMove: this.scrollStepOnDesktop,
                                slideMargin: this.slideMarginOnDesktop
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                item: this.displayedPerScrollOnTab,
                                slideMove: this.scrollStepOnTab,
                                slideMargin: this.slideMarginOnTab
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                item: this.displayedPerScrollOnMobile,
                                slideMove: this.scrollStepOnMobile,
                                slideMargin: this.slideMarginOnMobile
                            }
                        }
                    ],
                    highlights: [],
                    lastLoadedScene: -1,
                    onBeforeSlide: function (el, scene) {
                        this.loadSceneLocal(scene, this.highlights, this.lastLoadedScene);
                        if (scene > this.lastLoadedScene) {
                            this.lastLoadedScene = scene;
                        }
                    }.bind(this),
                    onAfterSlide: function(el) {
                        this.setArrowsVisibility(el);
                    }.bind(this),
                    onSliderLoad: function (el) {
                        this.highlights = $(el).find('.custom-highlight');
                        this.lastLoadedScene = -1;
                        this.loadSceneLocal(0, this.highlights, this.lastLoadedScene);
                        this.setArrowsVisibility(el);
                        $(this.$el).css("height", "");
                        this.slider = el;
                        this.slider.addClass("in");

                        this.slider.find(".score-highlight-body").dotdotdot({
                            height: 60
                        });

                        //this.slider.find("li").matchHeight(true);

                        eventManager.subscribe("refresh nested content slider", function (e) {
                            if (e.$paneToShow.has(this.$el).length) {
                                this.slider.refresh();
                                this.setArrowsVisibility(this.slider);
                            }
                        }.bind(this));

                    }.bind(this)
                });

                this.loaded = true;
            },
            methods: {
                setArrowsVisibility: function (el) {
                    var current = el.getCurrentSlideCount();
                    var total = el.getTotalSlideCount();
                    var slideMove = el.getSlideMove();
                    var perScroll = el.getItemsPerScroll();
                    var prevBtn = $("a.lSPrev", this.$el);
                    var nextBtn = $("a.lSNext", this.$el);

                    if (current === 1) {
                        prevBtn.hide();
                    } else {
                        prevBtn.show();
                    }

                    if (((current - 1) * slideMove) + perScroll >= total) {
                        nextBtn.hide();
                    } else {
                        nextBtn.show();
                    }
                },
                loadSceneLocal: function (scene, highlights, lastLoadedScene) {
                    if (!lastLoadedScene) {
                        return;
                    }

                    if (scene > lastLoadedScene) {
                        var loadItemImage = function (highlight) {
                            var imageHolder = $(highlight).find('.image-holder');
                            if (imageHolder) {
                                var imageUrl = $(imageHolder).val();
                                if (imageUrl) {
                                    $(highlight).find('img').attr('src', imageUrl);
                                } else {
                                    if ($(highlight).hasClass('custom-highlight-in-dynamic-content-slider')) {
                                        $(highlight).find('img').hide();
                                    }
                                }
                            }
                        }

                        if (scene * 4 > highlights.length) {
                            if (scene * 4 - highlights.length < 4) {
                                //load last 4 images in case that last scene can not be derived by 4
                                var j;
                                for (j = 1; j < 5; j++) {
                                    loadItemImage(highlights[highlights.length - j]);
                                }
                            }
                        }
                        else {
                            //load 4 images
                            var i;
                            for (i = 0; i < 4; i++) {
                                if (scene * 4 + i < highlights.length) { loadItemImage(highlights[scene * 4 + i]); }
                            }
                        }
                    }
                }
            }
        };

        return function init(args) {
            component.el = args.scope;
            component.data = {
                loaded: false,
                displayedPerScrollOnDesktop: args.DisplayedPerScrollOnDesktop,
                scrollStepOnDesktop: args.ScrollStepOnDesktop,
                slideMarginOnDesktop: args.SlideMarginOnDesktop,
                displayedPerScrollOnTab: args.DisplayedPerScrollOnTab,
                scrollStepOnTab: args.ScrollStepOnTab,
                slideMarginOnTab: args.SlideMarginOnTab,
                displayedPerScrollOnMobile: args.DisplayedPerScrollOnMobile,
                scrollStepOnMobile: args.ScrollStepOnMobile,
                slideMarginOnMobile: args.SlideMarginOnMobile,
                slider: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
